'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'suitcase';
var width = 512;
var height = 512;
var aliases = [129523];
var unicode = 'f0f2';
var svgPathData = ['M32 160l0 256c0 17.7 14.3 32 32 32l48 0 0-320-48 0c-17.7 0-32 14.3-32 32zm112-32l0 320 224 0 0-320-224 0zm256 0l0 320 48 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32l-48 0z', 'M208 32l96 0c8.8 0 16 7.2 16 16l0 48-128 0 0-48c0-8.8 7.2-16 16-16zM160 48l0 48-96 0C28.7 96 0 124.7 0 160L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-96 0 0-48c0-26.5-21.5-48-48-48L208 0c-26.5 0-48 21.5-48 48zm16 80l192 0 0 320-224 0 0-320 32 0zm-64 0l0 320-48 0c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l48 0zM400 448l0-320 48 0c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32l-48 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSuitcase = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;